import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import FileBase64 from 'react-file-base64';
import { TextField, FormControlLabel, Checkbox, Grid } from '@material-ui/core';
import { $TokenCreatePayment, $CustomerCreate, $CustomerUpdate, ACHProcessorEnum, CCProcessorEnum } from '../../services/V2/gozer';
import { ACHAccountHolderTypeEnum, ACHTypeEnum, BillingAccountStatusEnum, ContactTypeEnum,
    CreditCardTypeEnum,
    PaymentProcessorEnum, PaymentTransactionTypeEnum, PaymentTypeEnum, MetersVService, ServiceAddressesVService, ServiceAddressTypeEnum,
    ServiceTypeEnum, UtilityTypeEnum, ServiceStatusEnum } from '../../services/V2/gozer';
import { UserRolesVService } from '../../services/V2/keymaster';
import { handleError } from './Functions';
import { Autocomplete } from '@material-ui/lab';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

export function FormController({ keys, disabledKeys, extraKeys, editMode, model, setModel, canReadUserRoles, canReadServiceAddresses, canReadMeters, districtId }) {
    const [userRoles, setUserRoles] = useState<any[]>([]);
    const [serviceAddress, setServiceAddress] = useState<any>();
    const [meter, setMeter] = useState<any>();
    const [serviceAddresses, setServiceAddresses] = useState<any[]>([]);
    const [meters, setMeters] = useState<any[]>([]);
    const customerUpdateKeys = $CustomerUpdate.properties;
    const customerCreateKeys = $CustomerCreate.properties;
    const ccTokenKeys = $TokenCreatePayment.properties;
    const achTokenKeys = $TokenCreatePayment.properties;

    useEffect(() => {
        if(canReadUserRoles)
            UserRolesVService.userRolesVGetAll({
                    pageNumber: 1,
                    orderBy: "Name",
                    orderByDesc: false
                })
                .then((r:any) => setUserRoles(r.items.filter(f => f.allowedUserType === "Admin")))
                .catch(err => handleError(err))
    }, [canReadUserRoles])

    useEffect(() => {
        if(districtId && canReadServiceAddresses) {
            ServiceAddressesVService.serviceAddressesVGetAll({
                    pageNumber: 1,
                    orderBy: "City",
                    orderByDesc: false,
                    filters: [{property:"DistrictId", value: districtId}]
                })
                .then((a:any) => {
                    setServiceAddresses(a.items)
                    if(model.serviceAddressId){
                        setServiceAddress(a.items.filter(x => x.id === model.serviceAddressId)[0])
                    }
                })
                .catch(err => handleError(err))
        }
    }, [districtId])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(serviceAddress && canReadMeters){
            MetersVService.metersVGetAll(serviceAddress.id, {
                    pageNumber: 1,
                    orderBy: "MeterNumber",
                    orderByDesc: false,
                    filters: [{property:"ServiceAddressId", value: serviceAddress.id}]
                })
                .then((m:any) => {
                    setMeters(m.items)
                    if(model.meterId){
                        setMeter(m.items.filter(x => x.id === model.meterId)[0])
                    }
                })
                .catch(err => handleError(err))
        } else setMeters([]);
    }, [serviceAddress])// eslint-disable-line react-hooks/exhaustive-deps

    const handleChange = event => {
        let name = event.target.name;
        let value = event.target.value === "" ? null : event.target.value;

        if (event.target.type === "checkbox") {
            name = event.target.id;
            value = event.target.checked
        }
        setModel({
            ...model,
            [name]: value
        })
    }

    const handleChangeNested = (event, nestedName)=> {
        let name = event.target.name;
        let value = event.target.value === "" ? null : event.target.value;

        if (event.target.type === "checkbox") {
            name = event.target.id;
            value = event.target.checked
        }
        setModel({
            ...model,
            [nestedName]: {
                ...model[nestedName],
                [name]: value
            }
        })
    }

    const setFiles = (file) => {
        setModel({
            ...model,
            attachedFileEncodedData: file.base64.split(',')[1],
            attachedFilename: file.name
        })
    }

    return (
        <>
            {Object.keys(keys).map((p, index) => {
                if (keys[p].type === 'boolean')
                    return null;
                if(p.toLowerCase().includes('password'))
                    return (
                        <TextField
                            disabled={!editMode || disabledKeys.includes(p)}
                            key={index}
                            onChange={handleChange}
                            required={!keys[p].isNullable || keys[p].isRequired}
                            margin="normal"
                            name={p}
                            label={_.startCase(p)}
                            type="password"
                            value={model === undefined || model[p] === undefined ? "" : model[p]}
                            fullWidth
                        />);
                if(p.toLowerCase().includes('userroleid') && canReadUserRoles)
                    return (
                        <TextField style={{ width: '100%', textAlign: 'left' }}
                            disabled={!editMode || disabledKeys.includes(p)}
                            key={index}
                            select
                            onChange={handleChange}
                            required={!keys[p].isNullable || keys[p].isRequired}
                            margin="normal"
                            name={p}
                            label={_.startCase(p)}
                            type="string"
                            defaultValue={model === undefined || model[p] === undefined ? "" : model[p]}
                        >
                            {userRoles.map(r => {
                                return <option key={r} value={r.id}>
                                        {r.name}
                                    </option>
                            })}
                        </TextField>);
                if(p.toLowerCase().includes('serviceaddressid') && canReadServiceAddresses)
                    return (
                        <Autocomplete
                            data-testid='autocomplete'
                            value={serviceAddress || { value: ""}}
                            id="ServiceAddress"
                            options={serviceAddresses}
                            getOptionLabel={(option) => option?.value ?? `${option?.city ?? ""}, ${option?.street ?? ""}(${option?.meters?.length ?? 0})`}
                            renderOption={(option, { selected }) => (
                                <div style={{ width: "100%", textAlign:"center" }}>{option?.value ?? `${option?.city ?? ""}, ${option?.street ?? ""}(${option?.meters?.length ?? 0})`}</div>
                            )}
                            style={{ width: 250, paddingRight: "10px", paddingTop: "10px", color: "#fff" }}
                            renderInput={(params) => <TextField {...params} label="Service Address" variant="outlined" />}
                            getOptionSelected={(o, v) => o.id === v.id}
                            onChange={(e, o) => {
                                setServiceAddress(o)
                                setModel({
                                    ...model,
                                    serviceAddressId: o.id
                                })
                            }}
                        />);
                if(p.toLowerCase().includes('meterid') && canReadMeters){
                    if(!serviceAddress) return null;
                    return (
                        <Autocomplete
                            data-testid='autocomplete2'
                            value={meter || { value: ""}}
                            id="Meter"
                            options={meters}
                            getOptionLabel={(option) => option?.value ?? `${option?.meterNumber ?? "no number"} - ${option?.type ?? ""}`}
                            renderOption={(option, { selected }) => (
                                <div style={{ width: "100%", textAlign:"center" }}>{option?.value ?? `${option?.meterNumber ?? "no number"} - ${option?.type ?? ""}`}</div>
                            )}
                            style={{ width: 250, paddingRight: "10px", paddingTop: "10px", color: "#fff" }}
                            renderInput={(params) => <TextField {...params} label="Meter" variant="outlined" />}
                            getOptionSelected={(o, v) => o.id === v.id}
                            onChange={(e, o) => {
                                setMeter(o)
                                setModel({
                                    ...model,
                                    meterId: o.id
                                })
                            }}
                        />);
                }
                if(keys[p].type === 'number')
                    return (
                        <TextField
                            disabled={!editMode || disabledKeys.includes(p)}
                            key={index}
                            onChange={handleChange}
                            required={!keys[p].isNullable || keys[p].isRequired}
                            margin="normal"
                            name={p}
                            label={_.startCase(p)}
                            type="number"
                            value={model === undefined || model[p] === undefined ? "" : model[p]}
                            fullWidth
                        />);
                if(keys[p].format === 'date-time')
                    return (
                        <TextField
                            disabled={!editMode || disabledKeys.includes(p)}
                            key={index}
                            onChange={handleChange}
                            required={!keys[p].isNullable || keys[p].isRequired}
                            margin="normal"
                            name={p}
                            label={_.startCase(p)}
                            type="date"
                            value={model === undefined ||
                                model[p] === null ||
                                model[p] === "" ? "" :
                                model[p] instanceof Date ?
                                `${model[p].getFullYear()}-${model[p].getMonth()+1 < 10 ? "0" : ""}${model[p].getMonth()+1}-${model[p].getDate() < 10 ? "0" : ""}${model[p].getDate()}` :
                                model[p]}
                            fullWidth
                            InputLabelProps={{
                            shrink: true,
                            }}
                        />);
                if(keys[p].type === "CustomerCreate")
                    return (
                        Object.keys(customerCreateKeys).map((a, index2) =>
                            <TextField
                                key={`${index}-${index2}`}
                                disabled={!editMode || disabledKeys.includes(p)}
                                onChange={e => handleChangeNested(e, p)}
                                required={!customerCreateKeys[a].isNullable || customerCreateKeys[a].isRequired}
                                margin="normal"
                                name={a}
                                label={_.startCase(a)}
                                type="text"
                                value={model === undefined
                                    || model === null || model[p] === undefined || model[p][a] === undefined ? "" : model[p][a]}
                                fullWidth
                            />
                            ));
                if(keys[p].type === "CustomerUpdate")
                    return (
                        Object.keys(customerUpdateKeys).map((a, index2) =>
                            <TextField
                                key={`${index}-${index2}`}
                                disabled={!editMode || disabledKeys.includes(p)}
                                onChange={e => handleChangeNested(e, p)}
                                required={!customerUpdateKeys[a].isNullable || customerUpdateKeys[a].isRequired}
                                margin="normal"
                                name={a}
                                label={_.startCase(a)}
                                type="text"
                                value={model === undefined
                                    || model === null || model[p] === undefined || model[p][a] === undefined ? "" : model[p][a]}
                                fullWidth
                            />
                            ));
                if(p === "achTokenCreate")
                    return (model.paymentType === PaymentTypeEnum.ACH &&
                        Object.keys(achTokenKeys).map((a, index2) =>
                            <Grid container>
                                <Grid item xs={1}>
                                    <FiberManualRecordIcon style={{marginTop: "30px"}} />
                                </Grid>
                                <Grid item xs={11}>
                                    {achTokenKeys[a].type === "ACHProcessorEnum" &&
                                        <TextField style={{ width: '100%', textAlign: 'left' }}
                                            disabled={!editMode || disabledKeys.includes(a)}
                                            key={index}
                                            select
                                            onChange={e => handleChangeNested(e, p)}
                                            required={!achTokenKeys[a].isNullable || achTokenKeys[a].isRequired}
                                            margin="normal"
                                            name={a}
                                            label={_.startCase(a)}
                                            type="string"
                                            defaultValue={model === undefined || model[p] === undefined || model[p][a] === undefined ? "" : model[p][a]}
                                        >
                                            {Object.keys(ACHProcessorEnum).sort((a,b) => a.localeCompare(b)).map(r => {
                                                return <option key={r} value={ACHProcessorEnum[r]}>
                                                        {ACHProcessorEnum[r]}
                                                    </option>
                                            })}
                                        </TextField>
                                    }
                                    {achTokenKeys[a].type === "ACHAccountHolderTypeEnum" &&
                                        <TextField style={{ width: '100%', textAlign: 'left' }}
                                            disabled={!editMode || disabledKeys.includes(a)}
                                            key={index}
                                            select
                                            onChange={e => handleChangeNested(e, p)}
                                            required={!achTokenKeys[a].isNullable || achTokenKeys[a].isRequired}
                                            margin="normal"
                                            name={a}
                                            label={_.startCase(a)}
                                            type="string"
                                            defaultValue={model === undefined || model[p] === undefined || model[p][a] === undefined ? "" : model[p][a]}
                                        >
                                            {Object.keys(ACHAccountHolderTypeEnum).sort((a,b) => a.localeCompare(b)).map(r => {
                                                return <option key={r} value={ACHAccountHolderTypeEnum[r]}>
                                                        {ACHAccountHolderTypeEnum[r]}
                                                    </option>
                                            })}
                                        </TextField>
                                    }
                                    {achTokenKeys[a].type === "ACHTypeEnum" &&
                                        <TextField style={{ width: '100%', textAlign: 'left' }}
                                            disabled={!editMode || disabledKeys.includes(a)}
                                            key={index}
                                            select
                                            onChange={e => handleChangeNested(e, p)}
                                            required={!achTokenKeys[a].isNullable || achTokenKeys[a].isRequired}
                                            margin="normal"
                                            name={a}
                                            label={_.startCase(a)}
                                            type="string"
                                            defaultValue={model === undefined || model[p] === undefined || model[p][a] === undefined ? "" : model[p][a]}
                                        >
                                            {Object.keys(ACHTypeEnum).sort((a,b) => a.localeCompare(b)).map(r => {
                                                return <option key={r} value={ACHTypeEnum[r]}>
                                                        {ACHTypeEnum[r]}
                                                    </option>
                                            })}
                                        </TextField>
                                    }
                                    {achTokenKeys[a].type !== "ACHAccountHolderTypeEnum" && achTokenKeys[a].type !== "ACHProcessorEnum" && achTokenKeys[a].type !== "ACHTypeEnum" &&
                                        <TextField
                                            key={`${index}-${index2}`}
                                            disabled={!editMode || disabledKeys.includes(p)}
                                            onChange={e => handleChangeNested(e, p)}
                                            required={!achTokenKeys[a].isNullable || achTokenKeys[a].isRequired}
                                            margin="normal"
                                            name={a}
                                            label={_.startCase(a)}
                                            type="text"
                                            value={model === undefined
                                                || model === null || model[p] === undefined || model[p][a] === undefined ? "" : model[p][a]}
                                            fullWidth
                                        />
                                    }
                                </Grid>
                            </Grid>
                            ));
                if(p === "ccTokenCreate")
                    return (model.paymentType === PaymentTypeEnum.CC &&
                        Object.keys(ccTokenKeys).map((a, index2) =>
                            <Grid container>
                                <Grid item xs={1}>
                                    <FiberManualRecordIcon style={{marginTop: "30px"}} />
                                </Grid>
                                <Grid item xs={11}>
                                    {ccTokenKeys[a].type === "CCProcessorEnum" &&
                                        <TextField style={{ width: '100%', textAlign: 'left' }}
                                            disabled={!editMode || disabledKeys.includes(a)}
                                            key={index}
                                            select
                                            onChange={e => handleChangeNested(e, p)}
                                            required={!ccTokenKeys[a].isNullable || ccTokenKeys[a].isRequired}
                                            margin="normal"
                                            name={a}
                                            label={_.startCase(a)}
                                            type="string"
                                            defaultValue={model === undefined || model[p] === undefined || model[p][a] === undefined ? "" : model[p][a]}
                                        >
                                            {Object.keys(CCProcessorEnum).sort((a,b) => a.localeCompare(b)).map(r => {
                                                return <option key={r} value={CCProcessorEnum[r]}>
                                                        {CCProcessorEnum[r]}
                                                    </option>
                                            })}
                                        </TextField>
                                    }
                                    {ccTokenKeys[a].type === "CreditCardTypeEnum" &&
                                        <TextField style={{ width: '100%', textAlign: 'left' }}
                                            disabled={!editMode || disabledKeys.includes(a)}
                                            key={index}
                                            select
                                            onChange={e => handleChangeNested(e, p)}
                                            required={!ccTokenKeys[a].isNullable || ccTokenKeys[a].isRequired}
                                            margin="normal"
                                            name={a}
                                            label={_.startCase(a)}
                                            type="string"
                                            defaultValue={model === undefined || model[p] === undefined || model[p][a] === undefined ? "" : model[p][a]}
                                        >
                                            {Object.keys(CreditCardTypeEnum).sort((a,b) => a.localeCompare(b)).map(r => {
                                                return <option key={r} value={CreditCardTypeEnum[r]}>
                                                        {CreditCardTypeEnum[r]}
                                                    </option>
                                            })}
                                        </TextField>
                                    }
                                    {ccTokenKeys[a].type !== "CreditCardTypeEnum" && ccTokenKeys[a].type !== "CCProcessorEnum" &&
                                        <TextField
                                            key={`${index}-${index2}`}
                                            disabled={!editMode || disabledKeys.includes(p)}
                                            onChange={e => handleChangeNested(e, p)}
                                            required={!ccTokenKeys[a].isNullable || ccTokenKeys[a].isRequired}
                                            margin="normal"
                                            name={a}
                                            label={_.startCase(a)}
                                            type="text"
                                            value={model === undefined
                                                || model === null || model[p] === undefined || model[p][a] === undefined ? "" : model[p][a]}
                                            fullWidth
                                        />
                                    }
                                </Grid>
                            </Grid>
                            ));
                if(keys[p].type === "ServiceAddressTypeEnum")
                    return (
                        <TextField style={{ width: '100%', textAlign: 'left' }}
                            disabled={!editMode || disabledKeys.includes(p)}
                            key={index}
                            select
                            onChange={handleChange}
                            required={!keys[p].isNullable || keys[p].isRequired}
                            margin="normal"
                            name={p}
                            label={_.startCase(p)}
                            type="string"
                            defaultValue={model === undefined || model[p] === undefined ? "" : model[p]}
                        >
                            {Object.keys(ServiceAddressTypeEnum).sort((a,b) => a.localeCompare(b)).map(r => {
                                return <option key={r} value={ServiceAddressTypeEnum[r]}>
                                        {ServiceAddressTypeEnum[r]}
                                    </option>
                            })}
                        </TextField>);
                if(keys[p].type === "UtilityTypeEnum")
                    return (
                        <TextField style={{ width: '100%', textAlign: 'left' }}
                            disabled={!editMode || disabledKeys.includes(p)}
                            key={index}
                            select
                            onChange={handleChange}
                            required={!keys[p].isNullable || keys[p].isRequired}
                            margin="normal"
                            name={p}
                            label={_.startCase(p)}
                            type="string"
                            defaultValue={model === undefined || model[p] === undefined ? "" : model[p]}
                        >
                            {Object.keys(UtilityTypeEnum).sort((a,b) => a.localeCompare(b)).map(r => {
                                return <option key={r} value={UtilityTypeEnum[r]}>
                                        {UtilityTypeEnum[r]}
                                    </option>
                            })}
                        </TextField>);
                if(keys[p].type === "BillingAccountStatusEnum")
                    return (
                        <TextField style={{ width: '100%', textAlign: 'left' }}
                            disabled={!editMode || disabledKeys.includes(p)}
                            key={index}
                            select
                            onChange={handleChange}
                            required={!keys[p].isNullable || keys[p].isRequired}
                            margin="normal"
                            name={p}
                            label={_.startCase(p)}
                            type="string"
                            defaultValue={model === undefined || model[p] === undefined ? "" : model[p]}
                        >
                            {Object.keys(BillingAccountStatusEnum).sort((a,b) => a.localeCompare(b)).map(r => {
                                return <option key={r} value={BillingAccountStatusEnum[r]}>
                                        {BillingAccountStatusEnum[r]}
                                    </option>
                            })}
                        </TextField>);
                if(keys[p].type === "ContactTypeEnum")
                    return (
                        <TextField style={{ width: '100%', textAlign: 'left' }}
                            disabled={!editMode || disabledKeys.includes(p)}
                            key={index}
                            select
                            onChange={handleChange}
                            required={!keys[p].isNullable || keys[p].isRequired}
                            margin="normal"
                            name={p}
                            label={_.startCase(p)}
                            type="string"
                            defaultValue={model === undefined || model[p] === undefined ? "" : model[p]}
                        >
                            {Object.keys(ContactTypeEnum).sort((a,b) => a.localeCompare(b)).map(r => {
                                return <option key={r} value={ContactTypeEnum[r]}>
                                        {ContactTypeEnum[r]}
                                    </option>
                            })}
                        </TextField>);
                if(keys[p].type === "ServiceTypeEnum")
                    return (
                        <TextField style={{ width: '100%', textAlign: 'left' }}
                            disabled={!editMode || disabledKeys.includes(p)}
                            key={index}
                            select
                            onChange={handleChange}
                            required={!keys[p].isNullable || keys[p].isRequired}
                            margin="normal"
                            name={p}
                            label={_.startCase(p)}
                            type="string"
                            defaultValue={model === undefined || model[p] === undefined ? "" : model[p]}
                        >
                            {Object.keys(ServiceTypeEnum).sort((a,b) => a.localeCompare(b)).map(r => {
                                return <option key={r} value={ServiceTypeEnum[r]}>
                                        {ServiceTypeEnum[r]}
                                    </option>
                            })}
                        </TextField>);
                if(keys[p].type === "ACHAccountHolderTypeEnum")
                    return (
                        <TextField style={{ width: '100%', textAlign: 'left' }}
                            disabled={!editMode || disabledKeys.includes(p)}
                            key={index}
                            select
                            onChange={handleChange}
                            required={!keys[p].isNullable || keys[p].isRequired}
                            margin="normal"
                            name={p}
                            label={_.startCase(p)}
                            type="string"
                            defaultValue={model === undefined || model[p] === undefined ? "" : model[p]}
                        >
                            {Object.keys(ACHAccountHolderTypeEnum).sort((a,b) => a.localeCompare(b)).map(r => {
                                return <option key={r} value={ACHAccountHolderTypeEnum[r]}>
                                        {ACHAccountHolderTypeEnum[r]}
                                    </option>
                            })}
                        </TextField>);
                if(keys[p].type === "ACHTypeEnum")
                    return (
                        <TextField style={{ width: '100%', textAlign: 'left' }}
                            disabled={!editMode || disabledKeys.includes(p)}
                            key={index}
                            select
                            onChange={handleChange}
                            required={!keys[p].isNullable || keys[p].isRequired}
                            margin="normal"
                            name={p}
                            label={_.startCase(p)}
                            type="string"
                            defaultValue={model === undefined || model[p] === undefined ? "" : model[p]}
                        >
                            {Object.keys(ACHTypeEnum).sort((a,b) => a.localeCompare(b)).map(r => {
                                return <option key={r} value={ACHTypeEnum[r]}>
                                        {ACHTypeEnum[r]}
                                    </option>
                            })}
                        </TextField>);
                if(keys[p].type === "PaymentProcessorEnum")
                    return (
                        <TextField style={{ width: '100%', textAlign: 'left' }}
                            disabled={!editMode || disabledKeys.includes(p)}
                            key={index}
                            select
                            onChange={handleChange}
                            required={!keys[p].isNullable || keys[p].isRequired}
                            margin="normal"
                            name={p}
                            label={_.startCase(p)}
                            type="string"
                            defaultValue={model === undefined || model[p] === undefined ? "" : model[p]}
                        >
                            {Object.keys(PaymentProcessorEnum).sort((a,b) => a.localeCompare(b)).map(r => {
                                return <option key={r} value={PaymentProcessorEnum[r]}>
                                        {PaymentProcessorEnum[r]}
                                    </option>
                            })}
                        </TextField>);
                if(keys[p].type === "PaymentTypeEnum")
                    return (
                        <TextField style={{ width: '100%', textAlign: 'left' }}
                            disabled={!editMode || disabledKeys.includes(p)}
                            key={index}
                            select
                            onChange={handleChange}
                            required={!keys[p].isNullable || keys[p].isRequired}
                            margin="normal"
                            name={p}
                            label={_.startCase(p)}
                            type="string"
                            defaultValue={model === undefined || model[p] === undefined ? "" : model[p]}
                        >
                            {Object.keys(PaymentTypeEnum).sort((a,b) => a.localeCompare(b)).map(r => {
                                return <option key={r} value={PaymentTypeEnum[r]}>
                                        {PaymentTypeEnum[r]}
                                    </option>
                            })}
                        </TextField>);
                if(keys[p].type === "PaymentTransactionTypeEnum")
                    return (
                        <TextField style={{ width: '100%', textAlign: 'left' }}
                            disabled={!editMode || disabledKeys.includes(p)}
                            key={index}
                            select
                            onChange={handleChange}
                            required={!keys[p].isNullable || keys[p].isRequired}
                            margin="normal"
                            name={p}
                            label={_.startCase(p)}
                            type="string"
                            defaultValue={model === undefined || model[p] === undefined ? "" : model[p]}
                        >
                            {Object.keys(PaymentTransactionTypeEnum).sort((a,b) => a.localeCompare(b)).map(r => {
                                return <option key={r} value={PaymentTransactionTypeEnum[r]}>
                                        {PaymentTransactionTypeEnum[r]}
                                    </option>
                            })}
                        </TextField>);
                if(keys[p].type === "ServiceStatusEnum")
                    return (
                        <TextField style={{ width: '100%', textAlign: 'left' }}
                            disabled={!editMode || disabledKeys.includes(p)}
                            key={index}
                            select
                            onChange={handleChange}
                            required={!keys[p].isNullable || keys[p].isRequired}
                            margin="normal"
                            name={p}
                            label={_.startCase(p)}
                            type="string"
                            defaultValue={model === undefined || model[p] === undefined ? "" : model[p]}
                        >
                            {Object.keys(ServiceStatusEnum).sort((a,b) => a.localeCompare(b)).map(r => {
                                return <option key={r} value={ServiceStatusEnum[r]}>
                                        {ServiceStatusEnum[r]}
                                    </option>
                            })}
                        </TextField>);
                if(keys[p].type.endsWith("Enum")) console.log(keys[p].type)
                if(p === "attachedFileEncodedData")
                    return (
                        <FileBase64
                            multiple={false}
                            onDone={setFiles} />);
                if(p === 'attachedFilename')
                    return (
                        <TextField
                            key={index}
                            disabled={true}
                            onChange={handleChange}
                            required={!keys[p].isNullable || keys[p].isRequired}
                            margin="normal"
                            name={p}
                            label={_.startCase(p)}
                            type="text"
                            value={model === undefined || model[p] === undefined ? "" : model[p]}
                            fullWidth
                        />);
                return (
                    <TextField
                        key={index}
                        disabled={!editMode || disabledKeys.includes(p)}
                        onChange={handleChange}
                        required={!keys[p].isNullable || keys[p].isRequired}
                        margin="normal"
                        name={p}
                        label={_.startCase(p)}
                        type="text"
                        value={model === undefined
                            || model === null || model[p] === undefined ? "" : model[p]}
                        fullWidth
                    />);
            })}
            {Object.keys(keys).map((p, index) => {
                if(p.toLowerCase().includes("saved"))
                    return null;
                if (keys[p].type === 'boolean')
                    return (
                        <FormControlLabel style={{ paddingLeft: '10px', margin:'0px' }}
                            key={index}
                            label={_.startCase(p)}
                            labelPlacement="end"
                            control={
                                <Checkbox
                                    disabled={!editMode || p.toLowerCase().includes("active")}
                                    id={p}
                                    checked={(model === undefined
                                        || model === null || model[p] === undefined ? false : model[p])}
                                    onChange={handleChange}
                                    color="primary"
                                    required={!keys[p].isNullable || keys[p].isRequired}
                                    name={p} />
                        } />);
                return null;
            })}
            {extraKeys && Object.keys(extraKeys).map((p, index) => {
                if (extraKeys[p].type === 'boolean')
                    return (
                        <FormControlLabel style={{ paddingLeft: '10px', margin:'0px' }}
                            key={index}
                            label={_.startCase(p)}
                            labelPlacement="end"
                            control={
                                <Checkbox
                                    disabled={!editMode || p.toLowerCase().includes("active")}
                                    id={p}
                                    checked={(model === undefined
                                        || model === null || model[p] === undefined ? false : model[p])}
                                    onChange={handleChange}
                                    color="primary"
                                    required={!extraKeys[p].isNullable || extraKeys[p].isRequired}
                                    name={p} />
                        } />);
                return null;
            })}
        </>
    );
}